module.exports = __webpack_public_path__ + "static/media/ic_paid_well_red.38d3aef7.svg";